<template>
  <div class="per-page">
    <span class="title">{{ $t('Show') }}:</span>
    <ul>
      <li v-for="size in sizes" :class="{ '_active': size === pageSize }" @click="updatePageSize(size)">
        <span>{{ size }}</span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';

  @Component({
    name: 'product-list-size-select'
  })

  export default class extends Vue {
    @Prop({required: true}) readonly dataSource: string;

    private sizes: number[] = [12, 24, 32, 48, 64];

    get pageSize(): number {
      return Number(this.$store.getters[`${this.dataSource}/pageSize`]);
    }

    updatePageSize(size: number) {
      this.$store.dispatch(`${this.dataSource}/updatePageSize`, size);
    }
  }
</script>
